module.exports = __webpack_public_path__ + "static/og-2f05b7fefae46126e70ee59568629003.png";